import { Resources } from '@ragu-components/ord-resources';

import { UserNumberList } from './UserNumberList';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { UserNumber } from '@ragu-components/ord-types';

export const userNumbersResource: OrdResourceProps = {
  key: Resources.user_numbers,
  name: Resources.user_numbers,
  list: <UserNumberList />,
  hasShow: true,
  options: {},
  recordRepresentation: (record: UserNumber): string => record.number,
};
